<div class="ui inverted vertical center aligned segment">
    <div class="ui grid desktop">
        <div class="three wide column"></div>
        <div class="four wide column header-container">
            <h2 class="title">Votre garage</h2>
            <div class="separator"></div>
            <p class="description">Depuis 1982, la société Schiltz met son expertise à votre disposition, et ce, toujours
                avec la même envie de vous satisfaire. Vente, achat, réparation, location, voyages, ...
                découvrez tout de suite nos services.</p>
            <button (click)="discoverClicked()" class="ui button">Découvrez nos services</button>
        </div>
        <div class="nine wide column"></div>
    </div>

    <div class="smartphone">
        <h2 class="title">Votre garage</h2>
        <div class="separator"></div>
        <p class="description">Depuis 1982, la société Schiltz met son expertise à votre disposition, et ce, toujours
            avec la même envie de vous satisfaire. Vente, achat, réparation, location, voyages, ...
            découvrez tout de suite nos services.</p>
        <button (click)="discoverClicked()" class="ui button">Découvrez nos services</button>
    </div>
</div>


// WEBPACK FOOTER //
// C:/Users/Benoit/WebstormProjects/schiltz/client/src/app/presentation/components/garage/main/header/header.html